<template>
  <v-tooltip bottom color="info">
    <template v-slot:activator="{ on, attrs }">

      <v-btn v-bind="attrs"
             v-on="on"
             color="info white--text" :to="to" icon :target="target">
        <v-img max-width="20" max-height="20" src="/img/icons/info_circle.svg"></v-img>
      </v-btn>
    </template>
    رفتن به جزئیات
  </v-tooltip>

</template>

<script>
export default {
  props: {
    to: {
      required: true,
    },
    target: {
      default: '_blank',
    },
  },
};
</script>

<style>
</style>